/**
 * Live result of a CSS media query (false on the server / before mount).
 *   const tablet = useMediaQuery(`(max-width: ${BREAKPOINTS.DESKTOP_SMALL - 1}px)`);
 */
import * as React from "react";

export function useMediaQuery(query) {
  const get = () =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false;
  const [matches, setMatches] = React.useState(get);
  React.useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return undefined;
    const mql = window.matchMedia(query);
    const on = () => setMatches(mql.matches);
    on();
    mql.addEventListener?.("change", on);
    return () => mql.removeEventListener?.("change", on);
  }, [query]);
  return matches;
}

export default useMediaQuery;
